import * as React from "react";
import Modal from "react-modal";
import "./confirm-modal.less";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { shallowEqual } from "react-redux";
import {
  closeConfirmModal,
  selectConfirmModal,
} from "states/global-value/global-value.slice";
import { useAppDispatch, useAppSelector } from "app.hook";
Modal.setAppElement("#root");
export function ConfirmModal() {
  const dispatch = useAppDispatch();
  const confirmModalRedux = useAppSelector(selectConfirmModal, shallowEqual);
  return (
    <Modal
      portalClassName={"ReactModalPortalConfirm"}
      closeTimeoutMS={300}
      isOpen={confirmModalRedux?.isModal}
      onRequestClose={()=>{
        dispatch(closeConfirmModal());
      }}
      className={`drop-shadow top-1/4 relative outline-none rounded-md xl:w-1/4 mx-auto sm:w-full`}
      overlayClassName="Overlay"
    >
      <div className={`Confirm-Modal rounded-md p-4`}>
        <div className="modal-react-header">
          {confirmModalRedux?.title && (
            <h2 className="text-left text-xl font-semibold ">
              {confirmModalRedux?.title}
            </h2>
          )}
          <FontAwesomeIcon
            size="1x"
            className="cursor-pointer absolute right-2 top-2"
            onClick={() => {
              dispatch(closeConfirmModal())
            }}
            icon={faTimes}
          />
        </div>
        <div className="modal-react-content border-t border-b border-gray-300 py-2 mt-4">
          <p className="">{confirmModalRedux?.message}</p>
        </div>
        <div className="space-x-2 text-center pt-5 mx-auto py-2 border-gray-300 modal-react-footer">
          <button
            onClick={() => {
              dispatch(closeConfirmModal())
            }}
            className="btn--default px-8 transition-primary  uppercase btn--secondary hover:btn--secondary"
          >
            Cancel
          </button>
          <button
            onClick={confirmModalRedux?.onYes}
            className="btn--default px-8 transition-primary uppercase btn--primary"
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
}
